import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import BaseModal from './BaseModal';
import { inputTypes } from '../../utils/inputTypes';
import ModalForm from './ModalForm';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { createNew, editStation } from '../../actions/stationActions'
import { showSnackbar, closeSnackbar } from "../../actions/snackbarActions";

const styles = theme => ({

});

class StationModal extends React.Component {

  constructor(props) {
    super(props);

    // Array of inputs that dynamically build
    // up the editor form.
    this.formFields = [
      {
        id: "stationCode",
        name: "stationCode",
        label: "Station Code",
        type: inputTypes.textField,
        value: ""
      },
      {
        id: "name",
        name: "name",
        label: "Station Name",
        type: inputTypes.textField,
        value: ""
      },
      {
        id: "pumpnumbers",
        name: "pumpnumbers",
        label: "Pump numbers (e.g. 1,3,4)",
        type: inputTypes.textField,
        value: ""
      },
      {
        id: "address",
        name: "address",
        label: "Address",
        type: inputTypes.textField,
        value: ""
      },
      {
        id: "city",
        name: "city",
        label: "City",
        type: inputTypes.textField,
        value: ""
      }
    ];
  }

  // This function is called by the child component
  // (<BaseModal>) during its own submit function
  onSubmit = async (values) => {
    // Different action needs to be fired, depending on
    // whether creating new station or editing one.
    if (this.props.isEdit && this.props.selectedStation) {
      const id = this.props.selectedStation.id;
      const editedStation = {...values, id};
      await this.props.editStation(editedStation);
      this.props.showSnackbar("Station edited");
    } else {
      await this.props.createNew(values);
      this.props.showSnackbar("New station created");
    }
  }

  // Validation schema can be difficult to build dynamically
  // in the child component. For easiness, it's created here
  // and then passed down as prop
  validationSchema = Yup.object().shape({
    name: Yup.string().label("Station name").required().min(2),
    stationCode: Yup.string().label("Station Code").required().min(2),
    pumpnumbers: Yup.string().test("is-comma-separated", "Separate numbers with commas (e.g.: 1, 5, 6).", value => /^[0-9]+(,[0-9]+)*$/.test(value) === true).label("Pump numbers").required().min(1),
    address: Yup.string().label("Address").required().min(2),
    city: Yup.string().label("City").required().min(2)
  });

  render() {
    const {isOpen, handleClose, isEdit, selectedStation } = this.props;

    return (
      <BaseModal isEdit={isEdit} modalType="Station" onSubmit={this.onSubmit} isOpen={isOpen} handleClose={handleClose}>
        <ModalForm validationSchema={this.validationSchema} initialValues={selectedStation} formFields={this.formFields} handleCancel={handleClose} />
      </BaseModal>
    )
  }
}
export default
  compose(
    withStyles(styles),
    connect(null, { createNew, editStation, showSnackbar, closeSnackbar })
  )(StationModal);



// WEBPACK FOOTER //
// ./src/components/Modals/StationModal.js